const baseAdvertUrl = "Advert"


  const endpoints = {
   getAdvertList:`${baseAdvertUrl}/List`,
   saveFilter:`${baseAdvertUrl}/SaveFilter`,
   
   
  };
  
  export default endpoints;
  